import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import MainScreen from "../components/MainScreen";
import CircleCarousel from "../components/CircleCarousel";
import NewArrivalCarousel from "../components/NewArrivalCarousel";
import Cards from "../components/Cards";
import Brandcarousel from "../components/Brandcarousel";
import Footer from "../components/Footer";

const Kids = () => {
  return (
    <>
      {/* <Header />
      <Navbar />
      <SecondNavbar /> */}
      <MainScreen />
      <CircleCarousel />
      <NewArrivalCarousel />
      <Cards />
      <Brandcarousel />
      <Footer />
    </>
  );
};

export default Kids;
